import { ReactNode, Suspense } from 'react'
import { UIMatch, useMatches } from 'react-router-dom'
import { GlobalSidebar } from '@/components/sidebar/sidebarGlobal'
import { LocalSidebar } from '@/components/sidebar/sidebarLocal'
import { SidebarProvider } from '@/components/ui/sidebar'
import { Header } from '@/components/page/header'
import { Progress } from '@/components/layout/progress'
import { LoadingPage } from '@/pages/loading'
import { paths } from '@/config/paths'

type DashboardLayoutProps = {
  children: ReactNode
}

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const matches = useMatches() as UIMatch[]

  const isGlobalPage = matches.some((match) => match.pathname.includes(paths.admin.root.getHref()))

  return (
    <Suspense fallback={<LoadingPage />}>
      <SidebarProvider>
        {isGlobalPage ? <GlobalSidebar /> : <LocalSidebar />}
        <div className="flex flex-col w-full h-dvh overflow-hidden">
          <div className="relative">
            <Header />
            <Progress />
          </div>
          <main className="flex-grow w-full p-4 bg-accent overflow-y-auto relative flex flex-col">{children}</main>
        </div>
      </SidebarProvider>
    </Suspense>
  )
}

export { DashboardLayout }
